import React from 'react';
import PropTypes from 'prop-types';
import { themeGet } from '@firsttable/web-theme';
import styled from 'styled-components';
import Title from '../../atoms/Title/Title';
import Box from '../../atoms/Box/Box';

const StyledFAQ = styled(Box)`
  summary {
    cursor: pointer;
    list-style: none;
    position: relative;
    padding-right: 30px;
    ::-webkit-details-marker {
      display: none;
    }
  }
  summary:after {
    content: ' ';
    position: absolute;
    top: 8px;
    right: 0;
    border-right: 4px solid ${themeGet('colors.brand.blue')};
    border-bottom: 4px solid ${themeGet('colors.brand.blue')};
    width: 10px;
    height: 10px;
    transform: rotate(-315deg);
    transition: all 0.2s ease-out;
  }
  details {
    p {
      padding-right: 30px;
    }
  }
  details[open] {
  }
  details[open] summary:after {
    transform: rotate(-135deg);
    top: 14px;
  }
  &:first-child {
    details {
      border-top: none;
      padding-top: 0;
    }
  }
  :last-child {
    margin-bottom: 0;
  }
`;

const FAQ = ({ title, body }) => (
  <StyledFAQ>
    <Box
      as="details"
      open
      py={['s', 'xxl']}
      borderTop={[null, `1px solid ${themeGet('colors.grayscale.300')}`]}
    >
      <Title as="summary" size="h5" m={0} pb={12}>
        {title}
      </Title>
      {body}
    </Box>
  </StyledFAQ>
);

FAQ.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.any.isRequired,
};
export default FAQ;
